import React from 'react'
import { sponsorAppData } from '../../../data/sponsorAppData';
import SocialCard from '../../global/SocialCard';
import SponsorAppCard from '../../global/SponsorAppCard';

export default function SponsorAppsConfig() {
  return (
   <div className="w-full space-y-4 ">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {sponsorAppData.map((app, index) => (
            <SponsorAppCard name={app.name} des={app.des} cardKey={index} imgPath={app.icon} link={'https://lucide.dev/icons/square-arrow-out-up-right'} />
          ))}
        </div>
      </div>
  );
}
